import { Control } from '@Common/Controls';
import StylesHelper from '@Common/Helpers/StylesHelper';
import { GradientBackground } from '@InstanceFactory';

export class GradientPreviewControl implements Control {
    private readonly root: JQuery;

    constructor() {
        this.root = $('<div>').addClass('gradientEditor-gradientPreview');
    }

    public getControl(): JQuery {
        return this.root;
    }

    public adjust(w: number, h: number): void {
        this.root.width(w);
        if (h) {
            this.root.height(h);
        }
    }

    public update(val: GradientBackground): void {
        const background: string = StylesHelper.getBackground(val);
        this.root.css('background', background);
    }

    public setState(enabled: boolean): void {}
}
